import Panel from "../Panel/PanelShimmer";

export const ChildAmbassador = () => {
  const onClick = () => {
    window.location.href = "https://www.worldvision.org/sponsor-a-child/support-center/child-ambassadors";
  }

  return (
    <Panel classList="more-wv__ambassador" shimmerProps={{height: "400px", classList: 'more-wv__ambassador', testId: 'community-progress'}}
    showShimmer={false}>
      <h3 className="eta">Become a child ambassador</h3>
      <img src="https://wvusstatic.com/mywv/msc/feed/child-ambassadors.jpg" alt="child ambassadors" />
      <p>Join an uplifting community of doers pushing their faith into action. Get more information about the joy of helping more children find sponsors.</p>
      <button type="button" className="btn btn-small btn-ghost-orange" onClick={onClick}>
        Sign Up Now
      </button>
   </Panel>
  );
}

export default ChildAmbassador;